/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MobileVerificationCodeDto } from '../../models/mobile-verification-code-dto';
import { VerificationSuccessResponseDto } from '../../models/verification-success-response-dto';

export interface Verification$Params {
      body: MobileVerificationCodeDto
}

export function verification(http: HttpClient, rootUrl: string, params: Verification$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationSuccessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, verification.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VerificationSuccessResponseDto>;
    })
  );
}

verification.PATH = '/api/v1/verification';
